import * as echarts from 'echarts';
import ReactECharts from "echarts-for-react";
import { useLanguage } from "../../contexts/LanguageContext";
import translations from "../../translations";
import { returnChartColor } from '../../../utils/charts/colors';
import { Weather } from '../../../types/variables/Variables';

interface HourlyChartInterface {
  weather: Weather
  data: number[]
  categories: string[]
}

const HourlyChart = (props: HourlyChartInterface) => {
  const { weather, data, categories } = props;
  const { selectedLanguage } = useLanguage();

 
  const option = {
    color: [returnChartColor(weather)[0]],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        label: {
          backgroundColor: '#6a7985',
        },
      },
    },
    grid: {
      top: '5%',
      left: '0%',
      right: '2%',
      bottom: '5%',
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
      },
      data: categories,
    },
    yAxis: [
      {
        show: false,
        type: "value",
        name: "Temperatura (°C)",
        position: "left",
        axisLabel: {
          // show: false,
          formatter: "{value}°",
        },
      },
    ],
    series: [
      {
        name: `${translations[selectedLanguage].temperature}`,
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 1,
          color: returnChartColor(weather)[1],
        },
        symbol: "circle",
        symbolSize: 1,
        label: {
          show: true,
          position: "top",
          formatter: "{c}°",
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, 
            returnChartColor(weather)?.map((item, index) => ({
            offset: index,
            color: item
          })))
        },
        data: data,
      }
    ],
  };

  return <ReactECharts option={option} style={{ height: 300 }} />
}


export { HourlyChart }